import React, {Component} from "react";
import ReactDOM from "react-dom";
import App from "../../index.js";
import "../../../chrysler.css"
import { config } from "../../../configs/chrysler"
import loaderSvg from "../../../images/chrysler-loading.svg";

const brand =  {
    value: "chrysler",
    id: 3,
    division : "9",
    name : "Chrysler",
    website : "https://www.chrysler.com.au",

};

function Chrysler(props){
    return (
        <App brand={brand} formName={"fca-chrysler-cu"} config={config} loader={loaderSvg}/>
    )
}

ReactDOM.render(<Chrysler/>,document.getElementById("root"));
